import { z } from 'zod';
export var WorkspacesAPI;
(function (WorkspacesAPI) {
    WorkspacesAPI.transcribeFileRequestParamsSchema = z.object({
        fileId: z.coerce.number(),
        workspaceId: z.coerce.number(),
    });
    WorkspacesAPI.preFileUploadCheckRequestBodySchema = z.object({
        files: z.array(z.object({
            identifier: z.string(),
            name: z.string(),
            lastModified: z.number().optional(),
            size: z.number().optional(),
            type: z.string().optional(),
        })),
        parentObjectId: z.number(),
    });
    WorkspacesAPI.preFileUploadCheckRequestParamsSchema = z.object({
        workspaceId: z.coerce.number(),
    });
    WorkspacesAPI.preFileUploadCheckResponseBodySchema = z.object({
        existing: z.array(z.string()),
        transcribable: z.array(z.string()),
    });
})(WorkspacesAPI || (WorkspacesAPI = {}));
;
